var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-menu',{attrs:{"bottom":"","right":""}},[_c('v-icon',{attrs:{"slot":"activator","small":""},slot:"activator"},[_vm._v("\n    email\n  ")]),_c('v-list',{attrs:{"dense":""}},[_c('v-list-tile',{on:{"click":function($event){return _vm.sendSetupLink()}}},[_c('v-list-tile-title',[_vm._v("Re-send setup link")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }